/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_Rank_V5_HintInputs */



/**
* | output |
* | --- |
* | "V5 events cannot be championships — the VEKN calendar has no V5 championship type." |
*
* @param {Tfield_Rank_V5_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_rank_v5_hint = /** @type {((inputs?: Tfield_Rank_V5_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_Rank_V5_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les événements V5 ne peuvent pas être des championnats — le calendrier VEKN n'a pas de type championnat V5.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Los eventos V5 no pueden ser campeonatos — el calendario VEKN no tiene un tipo de campeonato V5.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Eventos V5 não podem ser campeonatos — o calendário VEKN não tem um tipo de campeonato V5.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gli eventi V5 non possono essere campionati — il calendario VEKN non ha un tipo campionato V5.")
	return /** @type {LocalizedString} */ ("V5 events cannot be championships — the VEKN calendar has no V5 championship type.")
});